import { ITopicBase } from './i-topic-base';
import { ITopicDisplayName } from './i-topic-display-name';

export interface ITopicWithTranslations extends ITopicBase {
  contentThemes: string[];
  displayNames: ITopicDisplayName[],
  parentId?: number;
}

export class TopicWithTranslations implements ITopicWithTranslations {
  constructor(
    public id: number,
    public name: string,
    public displayName: string,
    public channels: string[],
    public contentThemes: string[],
    public displayNames: ITopicDisplayName[],
    public parentId?: number,
  ) {}
}
